import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as ramda from 'ramda';
import { enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import logValueOnChange from '../commonActions/logValueOnChange';
import { UncomposedOptionPickerField } from './optionPickerField';
import localChangeSelector from '../selectors/localChangeSelector';
const prepareOptions = list => {
  const result = list.map(item => ({
    identifier: item.id,
    title: item.name
  }));
  return result;
};
const ComponentCodePicker = _ref => {
  let enabled = _ref.enabled,
    _ref$issueComponentCo = _ref.issueComponentCode,
    indexQuery = _ref$issueComponentCo.indexQuery,
    list = _ref$issueComponentCo.list,
    serverFilter = _ref.issueComponentCodeActions.serverFilter,
    label = _ref.label,
    _onChange = _ref.onChange,
    path = _ref.path,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    localChangeFunc = _ref.localChangeFunc,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? {} : _ref$active;
  const jobLens = ramda.lensPath(['active', 'report', 'jobID']);
  const activeJobID = ramda.view(jobLens, {
    active
  });
  useEffect(() => {
    serverFilter({
      job: [activeJobID]
    }, indexQuery);
  }, [indexQuery, activeJobID, serverFilter]);
  return /*#__PURE__*/React.createElement(UncomposedOptionPickerField, {
    className: "t-ccp",
    enabled: enabled,
    label: label,
    path: path,
    placeholder: "Select Component Code",
    onChange: args => _onChange(localChangeFunc(args)),
    options: prepareOptions(list),
    value: value
  });
};
ComponentCodePicker.propTypes = {
  enabled: PropTypes.bool.isRequired,
  issueComponentCode: PropTypes.shape({
    indexQuery: PropTypes.shape({}).isRequired,
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  issueComponentCodeActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  localChangeFunc: PropTypes.func.isRequired,
  active: PropTypes.shape({})
};
export { ComponentCodePicker as UncomposedComponentCodePicker };
export default entityComposition(ComponentCodePicker, ['issueComponentCode'], {
  active: state => state.issue.active,
  enabled: enabledSelector,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  path: newPathSelector,
  localChangeFunc: localChangeSelector
});